module.exports = __webpack_public_path__ + "static/logo-cb0c71c93f33058f83346bd7ab094770.png";